import { z } from 'zod';

import { listSearchSchema } from '@/shared/patterns/list-search';

import { legalPersonFilters, naturalPersonFilters } from './person.filters';

// `validateSearch` das listas (U07). Leve de propósito: é JS inicial.

const sheet = z.string().min(1).max(40).optional().catch(undefined);

/** `/pessoas-fisicas/todas` e `/pendentes`: página (a partir de 1), tamanho e os filtros do legado. */
export const naturalPersonListSearch = listSearchSchema({ ...naturalPersonFilters.shape, sheet });
/** `/pessoas-juridicas/todas` e `/pendentes`. */
export const legalPersonListSearch = listSearchSchema({ ...legalPersonFilters.shape, sheet });
